var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 291,
    viewBox: "0 0 256 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05387 218.187C3.37421 220.534 5.28138 222.295 7.62865 223.615L120.591 288.752C125.286 291.539 131.007 291.539 135.555 288.752L248.518 223.615C253.213 220.974 256 215.986 256 210.558V80.2842C256 74.8562 253.213 69.8682 248.518 67.2275L135.555 2.09054C130.861 -0.696848 125.139 -0.696848 120.591 2.09054L7.62865 67.2275C2.78739 69.8682 0 74.8562 0 80.2842V210.705C0 213.346 0.58682 215.84 2.05387 218.187Z",
    fill: "#009639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8366 195.155C91.8366 203.223 85.3816 209.678 77.3128 209.678C69.2441 209.678 62.7891 203.223 62.7891 195.155V95.5419C62.7891 87.7665 69.6842 81.4582 79.22 81.4582C86.1151 81.4582 94.1839 84.2456 99.0252 90.2605L103.426 95.5419L164.162 168.161V95.8353C164.162 87.7665 170.617 81.3115 178.686 81.3115C186.755 81.3115 193.21 87.7665 193.21 95.8353V195.448C193.21 203.223 186.315 209.532 176.779 209.532C169.884 209.532 161.815 206.744 156.974 200.729L91.8366 122.976V195.155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/nginx.63e0789fac1cc3a927c53707fadcd312.svg";
export { ForwardRef as ReactComponent };